import { module } from 'angular';

import { default as skillFilterName, SkillFilter } from './skill-filter.component.ajs';

export default module('hypervision.skill-view.custom.filter.skill', []).component(skillFilterName, new SkillFilter()).name;
